import { useState, useMemo } from 'react';
import useElenco from '../../hooks/useElenco';

// Scelta della dicitura con ricerca, più i campi per le sue variabili ({lavoratore}, {numero}, {periodo}).
const ETICHETTE = { lavoratore: 'Lavoratore', numero: 'Numero', periodo: 'Periodo', tipo_f24: 'Tipo F24' };

export default function DicituraScelta({ diciture, dicituraId, variabili, onCambia, onCambiaVariabili, onNuova }) {
  const [filtro, setFiltro] = useState('');
  const [aperto, setAperto] = useState(false);
  const scelta = diciture.find(d => d.id === dicituraId);
  const tipiF24 = useElenco('tipo_f24', Boolean(scelta?.variabili?.includes('tipo_f24')));

  const filtrate = useMemo(() => {
    const q = filtro.trim().toLowerCase();
    return diciture.filter(d => !q || d.testo.toLowerCase().includes(q) || (d.categoria || '').toLowerCase().includes(q));
  }, [diciture, filtro]);

  return (
    <div>
      <div style={styles.box}>
        <input
          type="text"
          aria-label="Dicitura"
          placeholder="Cerca dicitura… (facoltativa)"
          value={aperto ? filtro : (scelta ? scelta.testo : '')}
          onFocus={() => { setAperto(true); setFiltro(''); }}
          onBlur={() => setTimeout(() => setAperto(false), 150)}
          onChange={e => setFiltro(e.target.value)}
          style={styles.input}
        />
        {scelta && !aperto && (
          <button type="button" onClick={() => onCambia(null)} style={styles.togli} aria-label="Togli dicitura">×</button>
        )}
        {aperto && (
          <div style={styles.lista}>
            {filtrate.map(d => (
              <div key={d.id} onMouseDown={() => { onCambia(d); setAperto(false); }} style={styles.voce}>
                <span>{d.testo}</span>
                {d.automatica_gis && <span style={styles.auto}>automatica GIS</span>}
                <div style={styles.categoria}>{d.categoria}</div>
              </div>
            ))}
            {filtrate.length === 0 && <div style={styles.vuoto}>Nessuna dicitura</div>}
            {onNuova && <div onMouseDown={() => { setAperto(false); onNuova(filtro); }} style={styles.nuova}>+ Aggiungi nuova dicitura</div>}
          </div>
        )}
      </div>
      {scelta && scelta.variabili?.length > 0 && (
        <div style={styles.variabili}>
          {scelta.variabili.map(v => v === 'tipo_f24' ? (
            <select
              key={v}
              aria-label="Tipo F24"
              value={variabili?.[v] || ''}
              onChange={e => onCambiaVariabili({ ...variabili, [v]: e.target.value })}
              style={{ ...styles.input, flex: 1 }}
            >
              <option value="">Tipo F24…</option>
              {/* un valore già salvato e poi disattivato resta visibile */}
              {variabili?.[v] && !tipiF24.some(t => t.valore === variabili[v]) && <option value={variabili[v]}>{variabili[v]}</option>}
              {tipiF24.map(t => <option key={t.id} value={t.valore}>{t.valore}</option>)}
            </select>
          ) : (
            <input
              key={v}
              type="text"
              placeholder={ETICHETTE[v] || v}
              aria-label={ETICHETTE[v] || v}
              value={variabili?.[v] || ''}
              onChange={e => onCambiaVariabili({ ...variabili, [v]: e.target.value })}
              style={{ ...styles.input, flex: 1 }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  box: { position: 'relative' },
  input: { width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.9rem', boxSizing: 'border-box' },
  togli: { position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none', cursor: 'pointer', fontSize: '1.1rem', color: '#888' },
  lista: { position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '6px', boxShadow: '0 6px 18px rgba(0,0,0,0.12)', zIndex: 50, maxHeight: '300px', overflowY: 'auto', marginTop: '2px' },
  voce: { padding: '0.45rem 0.6rem', cursor: 'pointer', fontSize: '0.88rem', borderBottom: '1px solid #f4f4f4' },
  categoria: { color: '#999', fontSize: '0.72rem' },
  auto: { marginLeft: '0.4rem', fontSize: '0.68rem', background: '#F7F7EA', color: '#6b6b2f', padding: '0.05rem 0.35rem', borderRadius: '4px' },
  vuoto: { padding: '0.5rem 0.6rem', color: '#999', fontSize: '0.85rem' },
  nuova: { padding: '0.5rem 0.6rem', cursor: 'pointer', fontSize: '0.85rem', borderTop: '1px solid #eee', fontWeight: 600 },
  variabili: { display: 'flex', gap: '0.4rem', marginTop: '0.4rem' },
};
